import Model, { belongsTo } from "@ember-data/model";
import type DrugsAndDevicesRefundedJournalEvent from "parog-web/models/drugs-and-devices-refunded-journal-event";
import type MedicationPresentation from "parog-web/models/medication-presentation";

export default class MedicationDispense extends Model {
  @belongsTo("drugs-and-devices-refunded-journal-event", {
    async: false,
    inverse: "medicationDispenses"
  })
  declare drugsAndDevicesRefundedJournalEvent: DrugsAndDevicesRefundedJournalEvent;
  @belongsTo("medication-presentation", {
    async: false,
    inverse: "medicationDispenses"
  })
  declare medicationPresentation: MedicationPresentation;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "medication-dispense": MedicationDispense;
  }
}
